import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=d65a63fa&scoped=true"
import script from "./searchForm.vue?vue&type=script&lang=js"
export * from "./searchForm.vue?vue&type=script&lang=js"
import style0 from "./searchForm.vue?vue&type=style&index=0&id=d65a63fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65a63fa",
  null
  
)

export default component.exports